import { Link } from 'react-router-dom';
import { Card, Meter } from '../ui';
import type { Stats } from '../types';

// The first-run path, spelled out. Each step links to where it happens and checks
// itself off from real counts; the card disappears once the core loop has run.

interface Step {
  label: string;
  detail: string;
  to: string;
  done: boolean;
}

export function GetStarted({ stats }: { stats: Stats }) {
  const invoices = Object.values(stats.invoices.by_status).reduce((s, n) => s + n, 0) + stats.invoices.credit_notes;
  const steps: Step[] = [
    {
      label: 'Set your hourly rate',
      detail: 'You (and any techs) need a bill rate before time is worth money.',
      to: '/technicians',
      done: stats.counts.technicians > 0,
    },
    {
      label: 'Add your first client',
      detail: 'The company you’ll bill.',
      to: '/clients?new=1',
      done: stats.counts.clients > 0,
    },
    {
      label: 'Log your first hours',
      detail: 'The timesheet period creates itself.',
      to: '/timesheets?log=1',
      done: stats.counts.time_entries > 0,
    },
    {
      label: 'Turn time into an invoice',
      detail: 'The billing run groups unbilled time by client.',
      to: '/billing',
      done: invoices > 0,
    },
  ];

  const doneCount = steps.filter((s) => s.done).length;
  if (doneCount === steps.length) return null;

  return (
    <Card className="get-started">
      <div className="card-pad">
        <div className="row-between" style={{ marginBottom: 'var(--sp-2)' }}>
          <h3 style={{ fontSize: 'var(--fs-14)' }}>Get set up</h3>
          <span className="muted" style={{ fontSize: 'var(--fs-12)' }}>
            {doneCount} of {steps.length}
          </span>
        </div>
        <Meter fraction={doneCount / steps.length} title={`${doneCount} of ${steps.length} steps done`} />
        <ol className="checklist">
          {steps.map((s) => (
            <li key={s.label} className={s.done ? 'done' : ''}>
              <span className="cl-tick" aria-hidden>
                {s.done ? '✓' : ''}
              </span>
              {s.done ? (
                <span className="cl-label">{s.label}</span>
              ) : (
                <Link to={s.to} className="cl-label">
                  {s.label}
                </Link>
              )}
              <span className="cl-detail">{s.detail}</span>
            </li>
          ))}
        </ol>
      </div>
    </Card>
  );
}
